import type { Koordinaten, Polygon } from "../types";

export type Einheit = {
  readonly id: string;
  readonly name: string;
};

export type Untereinheit = {
  readonly id: string;
  readonly name: string;
};

export type Geraet = {
  readonly id: string;
  readonly name: string;
  readonly positionName: string;
  readonly untereinheit?: Untereinheit;
  readonly einheit: Einheit;
  readonly homebase?: Koordinaten;
};

export const moduleOptions = [
  "dashboard",
  "checklisten",
  "gefahrgut",
  "gefahrgutlight",
  "rettungskarten",
  "kartenmaterial",
  "navigation",
  "kontakte",
  "dokumente",
  "warnkarte",
  "extnavigation",
  "verzeichnis",
  "formulare",
  "patienten",
  "atemschutz",
  "info",
  "meldungen",
  "meldungenadmin",
  "statistics",
  "whiteboard",
  "personal",
  "einsatzleiterwiki",
] as const;

export type Modul = (typeof moduleOptions)[number];

export type MapLayerProviderData = {
  readonly id: string;
  readonly label: string;
};

export type HTTPAuth =
  | { type: "basic"; username: string; password: string }
  | { type: "bearerToken"; token: string };

export type WMSMapLayerProvider = MapLayerProviderData & {
  readonly type: "wms";
  readonly url: string;
  readonly auth?: HTTPAuth;
  readonly crs?: string;
  readonly layers: ReadonlyArray<WMSMapLayer>;
};

export type WMSMapLayer = {
  readonly id: string;
  readonly label: string;
  readonly layer: string;
  readonly opacity?: number;
  readonly attribution?: string;
};

export type ShapeMapLayerProvider = MapLayerProviderData & {
  readonly type: "shape";
  readonly layers: ReadonlyArray<ShapeMapLayer>;
};

export type ShapeMapLayer = {
  readonly id: string;
  readonly label: string;
  readonly url: string;
  readonly color?: string;
  readonly opacity?: number;
  readonly attribution?: string;
};

export type MapLayerProvider = WMSMapLayerProvider | ShapeMapLayerProvider;

export type ExternalPage = {
  readonly label: string;
  readonly url: string;
  readonly target?: "app" | "external";
  readonly showInMenu?: boolean;
};

export type LicenseData = Geraet & {
  readonly loadCount?: number;
  readonly portalKey: string;
  readonly alarmKey: string;
  readonly missionApiKey?: string;
  readonly fireboardKey?: string;
  readonly module: ReadonlyArray<Modul>;
  readonly warnkarte: ReadonlyArray<string>;
  readonly gueltigkeit?: number;
  readonly positionSenden: boolean;
  readonly positionSehen: boolean;
  readonly freeversion: boolean;
  readonly demo: boolean;
  readonly offlineArea?: Polygon;
  /**
   * Settings area protected by a PIN (new Datenportal): SHA-256 of "<licenseKey>:<pin>".
   * Kept up to date via the session heartbeat.
   */
  readonly settingsLock?: {
    readonly pinHash: string;
    /** Number of digits — the PIN entry shows that many fields. */
    readonly pinLength?: number;
  };
  readonly mapLayers?: ReadonlyArray<MapLayerProvider>;
  readonly features?: ReadonlyArray<string>;
  readonly externalPages?: ReadonlyArray<ExternalPage>;
  readonly settingsScheme?: string;
};
